export default {
    toastText: "Copiado!",
};
